export default "__VITE_ASSET__CFfDniww__"